// extracted by mini-css-extract-plugin
export default {"notfound":"FouroO4_notfound__SFA3P","notfound__content":"FouroO4_notfound__content__4gZd0","notfound__homeButton":"FouroO4_notfound__homeButton__NOdp7"};